import { UpdateMyWishlistInput } from '@spa/generated/graphql/graphql';
import { WishlistError } from '@spa/components/wishlist/wishlistTypes';
import { createAction } from '@reduxjs/toolkit';

export interface ApiUpdateMyWishlistRequestedPayload {
  readonly actionId: number;
  readonly input: UpdateMyWishlistInput;
  readonly parentActionId: number;
}

export const apiUpdateMyWishlistRequestedType = 'api/wishlist/updateMyWishlist--requested';
export const apiUpdateMyWishlistRequested = createAction<ApiUpdateMyWishlistRequestedPayload>(
  apiUpdateMyWishlistRequestedType
);
export type ApiUpdateMyWishlistRequestedAction = ReturnType<typeof apiUpdateMyWishlistRequested>;

export interface ApiUpdateMyWishlistSucceededPayload {
  readonly parentActionId: number;
  readonly requestedActionId: number;
}

export const apiUpdateMyWishlistSucceededType = 'api/wishlist/updateMyWishlist--succeeded';
export const apiUpdateMyWishlistSucceeded = createAction<
  ApiUpdateMyWishlistSucceededPayload,
  typeof apiUpdateMyWishlistSucceededType
>(apiUpdateMyWishlistSucceededType);
export type ApiUpdateMyWishlistSucceededAction = ReturnType<typeof apiUpdateMyWishlistSucceeded>;

export interface ApiUpdateMyWishlistFailedPayload {
  readonly parentActionId: number;
  readonly requestedActionId: number;
  readonly errors: ReadonlyArray<WishlistError>;
}

export const apiUpdateMyWishlistFailedType = 'api/wishlist/updateMyWishlist--failed';
export const apiUpdateMyWishlistFailed = createAction<
  ApiUpdateMyWishlistFailedPayload,
  typeof apiUpdateMyWishlistFailedType
>(apiUpdateMyWishlistFailedType);
export type ApiUpdateMyWishlistFailedAction = ReturnType<typeof apiUpdateMyWishlistFailed>;
